<template>
  <div class="ofi-list">
    <propertyItem
      v-for="(property, index) in properties"
      :key="property.id || index"
      :index="index"
      :property="property"
      :screen-mode="screenMode"
    />
  </div>
</template>

<script>
import Vue from "vue";
import propertyItem from "./PropertyItem.vue";

export default Vue.extend({
  name: "PropertyList",
  components: { propertyItem },
  props: {
    properties: {
      type: Array,
      required: true,
    },
    screenMode: {
      type: String,
      default: "wide",
    },
  },
});
</script>

<style>
.ofi-list {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: var(--gap-rows);
}
</style>
